<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">PODCASTS</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createPodcast">Create Podcast</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="podcasts.columns" :data="podcasts.data">
                    <template slot="table-row" v-if="podcasts.data.length">
                        <tr v-for="(item, index) in podcasts.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.serviceName}}</td>
                            <td>
                              <!-- div style="width:600px; word-wrap: break-word;">{{item.podcastUrl}}</div>
                              <iframe :src="item.podcastUrl" loading= "lazy" width="100%" height="200" frameborder="1" scrolling="no" ></iframe -->
                              {{item.title}}
                            </td>
                            <td>{{item.description}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <!-- button class="btn btn-secondary btn-sm" @click="viewPodcast(item)" v-tooltip.top-center="podcasts.tooltips.view"><i class="fa fa-eye"></i></button -->
                                    <button class="btn btn-info btn-sm" @click="editPodcast(item)" v-tooltip.top-center="podcasts.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const podcastsColumns = ['Service', 'Title', 'Description', 'Status', 'Operations'];
    export default {
        name: 'podcasts',
        components: {
            LTable,
        },
        data() {
            return {
                  podcasts: {
                    tooltips: {
                        view: 'View Podcast',
                        edit: 'Edit Podcast',
                        delete: 'Inactivate Podcast',
                        activate:'Activate Podcast',
                    },
                    columns: [...podcastsColumns],
                    tableRowClass: {
                        classname: 'badge-warning',
                        classActiveCondition: 'status'
                    },
                    data: []
                }
            }
        },
        methods: {
            fetchPodcasts () {
                this.$store.dispatch('FETCH_PODCASTS')
                    .then((res) => {
                        this.podcasts.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    }),
                    (err) => {
                        console.log("err : ", err);
                    }
                },
                editPodcast(podcast){
                    this.$router.push({name: 'EditPodcast', params: {id: podcast.podcastId}})
                },
                createPodcast(){
                    this.$router.push({name: 'CreatePodcast'})
                },
        },
        created() {
            this.fetchPodcasts();
        }
    } // end of export default()
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/PodcastList.vue